import { useTranslator } from '$hooks';
import { useSelector } from 'react-redux';
import React, { useCallback } from 'react';
import { store } from '$store/store';
import { Truncate } from '$shared/components';
import { agePopoverHiddenSelector, mainActions } from '$store/main';
import { Button } from '$uikit';

export const AgePopover = () => {
  const t = useTranslator();
  const isHidden = useSelector(agePopoverHiddenSelector);

  const handleEnter = useCallback(() => {
    store.dispatch(mainActions.setAgePopoverHidden());
  }, []);

  const handleClose = useCallback(() => {
    window.history.back();
  }, []);

  if (isHidden) {
    return null;
  }

  return (
    <div className="AuthPopover__wrapper">
      <div className="AuthPopover__bg" />
      <div className="AuthPopover">
        <div className="AuthPopover__body">
          <div className="AuthPopover__content" style={{ paddingTop: 24 }}>
            <div
              className="AuthPopoverSimple__header left"
              style={{ justifyContent: 'space-between' }}
            >
              {t('age_restriction_title')}
            </div>
            <div className="AuthPopover__text AuthPopover__text_age">
              <Truncate text={t('age_restriction_text')} />
            </div>
            <Button style={{ marginTop: 16 }} onClick={handleEnter}>
              {t('age_restriction_enter')}
            </Button>
            <Button mode="inline" style={{ marginTop: 8 }} onClick={handleClose}>
              {t('age_restriction_leave')}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};
